import React, { useState } from 'react'
import { Container, Modal } from 'react-bootstrap'

const ImmobilizerModal = (props) => {

    // const [isLoading, setIsLoading] = useState(false)

    return (
        <Modal show={props.show}
            dialogClassName="modal-30w"
            onHide={props.closeModal}
            aria-labelledby="Fiilter">
            <Modal.Header closeButton>{props?.title}</Modal.Header>
            <Modal.Body className="show-grid">
                <Container>
                    {props?.children}
                </Container>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    style={{ fontSize: "12px" }}
                    className="btn btn-small"
                    onClick={props.closeModal}
                >
                    Close
                </button>
                <button
                    style={{
                        fontSize: "12px",
                        backgroundColor: "#007bff",
                        color: "#ffffff",
                    }}
                    // disabled={isLoading}
                    className="btn btn-small"
                    onClick={() => props?.handleSubmit()}
                >
                    {/* {isLoading && <i className="fa fa-spinner fa-spin "></i>} Apply */}
                    Apply
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default ImmobilizerModal
